import React, { useState, useEffect } from 'react';
import { getApiUrl, getDataUrl } from '../utils/apiConfig';
import './ReportSection.css';

const ReportSectionDownload = ({ selectedWorkshop, selectedWorkshopDetails }) => {
  
  let wsRAV = selectedWorkshopDetails?.reportAutomationVariables || {};
  let wsName = selectedWorkshop ? selectedWorkshop.name : "";  
  
  const [fileExists, setFileExists] = useState({
    old: false,
    newEn: false,
    newNative: false
  });
  
  const base = getDataUrl() + "/";
  const apiBase = getApiUrl() + "/";

  useEffect(() => {
    const checkFileExistence = async () => {
      if (!wsName) return;
      
      try {
        console.log('Checking file existence for workshop:', wsName);
        const [oldResponse, enResponse, nativeResponse] = await Promise.all([
          fetch(`${apiBase}file-exists/old/${encodeURIComponent(wsName)}`),
          fetch(`${apiBase}file-exists/new-en/${encodeURIComponent(wsName)}`),
          fetch(`${apiBase}file-exists/new-native/${encodeURIComponent(wsName)}`)
        ]);
        
        const [oldData, enData, nativeData] = await Promise.all([
          oldResponse.json(),
          enResponse.json(),
          nativeResponse.json()
        ]);
        
        setFileExists({
          old: oldData.exists,
          newEn: enData.exists,
          newNative: nativeData.exists
        });
      } catch (error) {
        console.error('Error checking file existence:', error);
        setFileExists({
          old: false,
          newEn: false,
          newNative: false
        });
      }
    };
    
    checkFileExistence();
  }, [wsName, apiBase]);

  return (
    <section className='mb-6'>    
      
        <div className="hero-body">
          <div className="container"> 
          <div className="columns is-centered">
            <div className="column is-10 has-text-centered">
              <div className="columns is-centered">
                {/* <div className="column is-4">
                  <a id="dl-btn-old" href={base + 'PDFs/old/' + wsName + '.pdf'} className='button is-large is-fullwidth dl-btn' download disabled={!fileExists.old}>
                    <span className="icon is-large">
                      <i className="fas fa-download"></i>
                    </span>
                    <span>Old report</span>
                  </a>
                </div> */}
                <div className="column is-5">
                  <a id="dl-btn-en" href={base + 'PDFs/new-en/' + wsName + ' EN.pdf'} className='button is-large is-fullwidth dl-btn' download disabled={!fileExists.newEn}>
                    <span className="icon is-large">
                      <i className="fas fa-download"></i>
                    </span>
                    <span>View report (EN)</span>
                  </a>
                </div>
                <div className="column is-5">
                  <a id="dl-btn-native" href={base + 'PDFs/new-native/' + wsName + '.pdf'} className='button is-large is-fullwidth dl-btn' download disabled={!fileExists.newNative}>
                    <span className="icon is-large">
                      <i className="fas fa-download"></i>
                    </span>
                    <span>View report ({selectedWorkshop?.country_code || 'local'})</span>
                  </a>
                </div>
              </div>
              <p className='has-text-weight-light mt-1'>for workshop {wsName} {wsRAV.text_workshop_country ? `(${wsRAV.text_workshop_country})` : ""}</p>
            </div>   
            </div>                          
          </div>
        </div>
      
  </section>
  );
};

export default ReportSectionDownload;
